import React from "react"

import Page from "@components/Page"

import ReportsList from "./ReportsList";

const LABEL_TITLE = "Reports"


const ReportsPage = () => {
  return (
    <Page title={LABEL_TITLE}>
      <ReportsList />
    </Page>
  )
}

export default ReportsPage
